import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { SynopticStandardUtils } from '@connect-services/client/components/synoptic/synoptic-graph/synoptic-standard-color.utils';
import { ColorEnum } from '@connect-services/client/components/synoptic/synoptic-plan/plan-core/synoptic-plan.constants';
import { CableDirectionEnum } from '@connect-services/client/sdk/api';
import { SynopticPlanEditService } from '@connect-services/client/services/synoptic/edit/synoptic-plan-edit.service';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-cassette-anchor-edit',
    styleUrl: './cassette-anchor-edit.component.scss',
    templateUrl: './cassette-anchor-edit.component.html',
})
export class CassetteAnchorEditComponent {
    public readonly anchorId = input.required<string>();
    public readonly cassetteKey = input.required<string>();
    public readonly fiberNumber = input.required<string | null>();
    public readonly isContinue = input.required<boolean>();
    public readonly positionId = input.required<string | null>();
    public readonly side = input.required<CableDirectionEnum>();

    protected readonly fiberColor = computed<string>(() => this.getColor(this.fiberNumber()));
    protected readonly isCassettePositionSelected = computed<boolean>(() => {
        if (!this.positionId()) {
            return false;
        }

        const selectedCassettePosition = this.synopticPlanEditService.selectedCassettePosition();

        return (
            selectedCassettePosition?.key === this.cassetteKey() &&
            selectedCassettePosition.side === this.side() &&
            selectedCassettePosition.position === this.positionId()
        );
    });
    protected readonly isSelectionEnabled = computed<boolean>(() => {
        const fiberSelected = this.synopticPlanEditService.selectedCableFiber();

        return !this.fiberNumber() && (!fiberSelected || fiberSelected.side === this.side());
    });
    // eslint-disable-next-line @typescript-eslint/member-ordering
    protected readonly CableDirectionEnum = CableDirectionEnum;

    private readonly synopticPlanEditService = inject(SynopticPlanEditService);

    protected selectCassettePosition(side: CableDirectionEnum, position?: string | null): void {
        if (!position) {
            return;
        }

        const selectedElement = this.synopticPlanEditService.selectedCassettePosition();

        if (
            selectedElement?.key === this.cassetteKey() &&
            selectedElement.side === side &&
            selectedElement.position === position
        ) {
            this.synopticPlanEditService.selectedCassettePosition.set(null);

            return;
        }

        this.synopticPlanEditService.selectedCassettePosition.set({
            key: this.cassetteKey(),
            position,
            side,
        });
    }

    private getColor(fiberPosition: string | null): string {
        const position = Number(fiberPosition);
        if (!fiberPosition || Number.isNaN(position)) {
            return ColorEnum.BLACK;
        }

        return SynopticStandardUtils.getStandardColor(position);
    }
}
